var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchedTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12116_20454",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68828 17.3565L16.0443 10.0218L8.70954 2.66579L1.35355 10.0005L8.68828 17.3565Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12116_20454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28628 9.25837C9.16862 9.25124 9.05637 9.27106 8.95506 9.31227C8.83325 9.36177 8.70035 9.27044 8.70054 9.13896L8.70195 8.16183C8.70255 7.73904 8.36029 7.39579 7.93751 7.39518L6.96038 7.39376C6.8289 7.39357 6.73794 7.26039 6.78781 7.13874C6.82931 7.03754 6.84946 6.92535 6.84266 6.80768C6.82095 6.43184 6.51833 6.12509 6.14279 6.09869C5.70123 6.06765 5.33305 6.41635 5.33241 6.85144C5.33228 6.95182 5.35173 7.04764 5.38715 7.1353C5.43669 7.2578 5.34659 7.39143 5.21445 7.39124L4.23732 7.38982C3.81451 7.38921 3.47126 7.73147 3.47065 8.15427L3.46925 9.12913C3.46905 9.26 3.60088 9.35152 3.72239 9.30298C3.82363 9.26257 3.93565 9.2434 4.05293 9.25099C4.4273 9.27531 4.73126 9.57828 4.75653 9.9526C4.78636 10.3943 4.43658 10.7615 4.00145 10.7609C3.90278 10.7608 3.80857 10.7417 3.72222 10.7072C3.59992 10.6583 3.46691 10.7478 3.46672 10.8796L3.46531 11.8545C3.46468 12.2772 3.80694 12.6205 4.22975 12.6211L5.20462 12.6225C5.33547 12.6227 5.42701 12.4909 5.37847 12.3694C5.33803 12.2681 5.31887 12.1561 5.32648 12.0388C5.35077 11.6645 5.65375 11.3605 6.02806 11.3352C6.46975 11.3054 6.83702 11.6552 6.83639 12.0903C6.83623 12.189 6.81719 12.2832 6.78269 12.3695C6.73381 12.4919 6.82331 12.6249 6.95502 12.6251L7.92993 12.6265C8.35274 12.6271 8.69598 12.2848 8.6966 11.862L8.69801 10.8849C8.6982 10.7527 8.83208 10.663 8.95443 10.7129C9.042 10.7486 9.13775 10.7683 9.23814 10.7685C9.67323 10.7691 10.023 10.4019 9.99323 9.9603C9.96793 9.58468 9.66205 9.28117 9.28628 9.25837Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7776 12.6319L12.1815 12.6311C12.05 12.6309 11.9586 12.7638 12.0081 12.8856C12.0493 12.9869 12.0692 13.0992 12.062 13.2168C12.0392 13.5926 11.7357 13.8985 11.3601 13.9238C10.9185 13.9535 10.5513 13.6038 10.5519 13.1687C10.5521 13.0683 10.5718 12.9725 10.6075 12.885C10.6574 12.7626 10.5677 12.6287 10.4355 12.6286L9.45839 12.6271C9.03558 12.6265 8.69333 12.2833 8.69394 11.8605",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70129 8.16232C8.7019 7.73951 9.04515 7.39726 9.46796 7.39787L10.4428 7.39928C10.5737 7.39947 10.6648 7.53157 10.6159 7.65295C10.5752 7.75406 10.5557 7.86603 10.563 7.98331C10.5862 8.35776 10.8883 8.66258 11.2625 8.68894C11.7042 8.72007 12.0724 8.37136 12.073 7.93622C12.0732 7.83755 12.0544 7.74328 12.0202 7.65683C11.9716 7.53439 12.0615 7.40162 12.1932 7.40183L13.1681 7.40324C13.5909 7.40384 13.9332 7.74709 13.9326 8.16989L13.9312 9.14704C13.931 9.27918 14.0646 9.36927 14.1871 9.31975C14.2748 9.28431 14.3706 9.26486 14.471 9.265C14.9061 9.26563 15.2548 9.63381 15.2237 10.0754C15.1973 10.4509 14.8906 10.7535 14.5147 10.7752C14.3971 10.782 14.2849 10.7619 14.1837 10.7204C14.062 10.6705 13.9288 10.7615 13.9286 10.893L13.9278 11.469",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchedTransparent);
export default __webpack_public_path__ + "static/media/matched-transparent.bbd995470d018e9871503496cc140825.svg";
export { ForwardRef as ReactComponent };